/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';

interface InitializedAvatarArgs {
  firstName?: string;
  lastName?: string;
  email?: string;
  backgroundColor?: string;
  icon?: string;
}

const backgroundColors = [
  'bg-ink-500',
  'bg-ink-700',
  'bg-ink-900',
  'bg-teal-900',
  'bg-plum-700',
  'bg-plum-900',
  'bg-yellow-900',
  'bg-clementine-700',
  'bg-clementine-900',
  'bg-green-900',
  'bg-blue-900',
  'bg-raspberry-900',
];

export default class InitializedAvatar extends Component<InitializedAvatarArgs> {
  get initial() {
    if (this.args.firstName) {
      return this.args.firstName[0].toUpperCase();
    }
    if (this.args.lastName) {
      return this.args.lastName[0].toUpperCase();
    }
    if (this.args.email) {
      return this.args.email[0].toUpperCase();
    }
    if (this.args.icon) {
      return this.args.icon;
    }
    return 'A'; //for Anonymous
  }

  get bgColor() {
    if (this.args.backgroundColor?.startsWith('#')) {
      return `background-color: ${this.args.backgroundColor};`;
    }
    return '';
  }

  get pickedBackground() {
    if (this.args.backgroundColor != null) {
      return this.args.backgroundColor;
    }

    let offset = this.initial.charCodeAt(0);
    return backgroundColors[offset % backgroundColors.length];
  }
}
